import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import useAuth from './useAuth';

// Plain axios for the public endpoint (no auth needed)
const publicApi = axios.create({ baseURL: process.env.REACT_APP_API_URL });

export function usePublicGallery() {
    const galleryQuery = useQuery({
        queryKey: ['gallery-public'],
        queryFn: () => publicApi.get('/gallery/getPhotos').then((res) => res.data),
    });

    return {
        photos: galleryQuery?.data?.photos || [],
        isGalleryLoading: galleryQuery.isLoading,
    };
}

export default function useGallery() {
    const { request } = useAuth();
    const queryClient = useQueryClient();

    const galleryQuery = useQuery({
        queryKey: ['gallery'],
        queryFn: () => request.get('/gallery/getPhotos').then((res) => res.data),
    });

    const addPhotosMutation = useMutation({
        mutationFn: (formData) => request.post('/gallery/addPhotos', formData),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['gallery'] });
            queryClient.invalidateQueries({ queryKey: ['gallery-public'] });
        },
    });

    const deletePhotoMutation = useMutation({
        mutationFn: (id) => request.delete('/gallery/deletePhoto', { data: { id } }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['gallery'] });
            queryClient.invalidateQueries({ queryKey: ['gallery-public'] });
        },
    });

    return {
        photos: galleryQuery?.data?.photos || [],
        isGalleryLoading: galleryQuery.isLoading,

        addPhotos: addPhotosMutation.mutateAsync,
        isAddingPhotos: addPhotosMutation.isPending,

        deletePhoto: deletePhotoMutation.mutateAsync,
        isDeletingPhoto: deletePhotoMutation.isPending,
    };
}
